import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { WinAnimation } from '../components/WinAnimation';
import './CasinoScratch.css';

const PRIZES = [0, 0, 0, 0.5, 1, 1, 2, 2, 5, 10];

export function CasinoScratch() {
  const { gameState, placeBet, addBalance, setLastWin, recordSpin, betOptions } = useGame();
  const [scratched, setScratched] = useState(false);
  const [multiplier, setMultiplier] = useState(0);
  const [lastWin, setLastWinLocal] = useState(0);
  const [showWinAnim, setShowWinAnim] = useState(false);

  const canPlay = gameState.balance >= gameState.bet && !scratched;

  const play = useCallback(() => {
    if (!canPlay) return;
    addBalance(-gameState.bet);
    const mult = PRIZES[Math.floor(Math.random() * PRIZES.length)];
    setMultiplier(mult);
    setScratched(true);
    const win = gameState.bet * mult;
    if (win > 0) {
      setLastWin(win);
      setLastWinLocal(win);
      setShowWinAnim(true);
      recordSpin(true);
    } else recordSpin(false);
  }, [canPlay, gameState.bet, addBalance, setLastWin, recordSpin]);

  const reset = useCallback(() => {
    setScratched(false);
    setMultiplier(0);
  }, []);

  return (
    <div className="casino-scratch">
      {showWinAnim && lastWin > 0 && (
        <WinAnimation amount={lastWin} isBonus={multiplier >= 5} onEnd={() => setShowWinAnim(false)} />
      )}
      <div className="scratch-container">
        <Link to="/" className="casino-back">← Takaisin</Link>
        <div className="casino-balance-bar">
          <span className="balance-value">€{gameState.balance}</span>
          {!scratched && (
            <select value={gameState.bet} onChange={(e) => placeBet(Number(e.target.value))} className="bet-select">
              {betOptions.map((b) => (
                <option key={b} value={b}>€{b % 1 ? b.toFixed(1) : b}</option>
              ))}
            </select>
          )}
        </div>
        <h1 className="scratch-title">🎫 Arpalappu</h1>
        <p className="scratch-rules">Osta lappu – voitto 0.5× – 10×</p>
        <div className="scratch-card">
          {scratched ? (
            <div className="scratch-result">
              <span className="scratch-mult">{multiplier}×</span>
              <span className="scratch-win">€{(gameState.bet * multiplier).toFixed(2)}</span>
              <button type="button" className="spin-button" onClick={reset}>Uusi lappu</button>
            </div>
          ) : (
            <div className="scratch-cover">
              <span className="scratch-hint">?</span>
              <button type="button" className="spin-button" onClick={play} disabled={!canPlay}>
                Osta €{gameState.bet}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
